import axios from '../config/axios';
import { GuestCartResponse } from '../interface/interface';
import { Endpoints } from './endPoints';

const getGuestCart = async (): Promise<GuestCartResponse> => {
  try {
    const guestCartId = sessionStorage.getItem('guestCartId');

    if (!guestCartId) {
      return {
        success: false,
        message: 'No cart found',
      };
    }

    const response = await axios.post(Endpoints.GET_GUEST_CART, {
      cart_id: guestCartId,
    });

    if (response.status === 200 && response.data) {
      return {
        success: true,
        cart: response.data.cart,
      };
    }

    return {
      success: false,
      message: 'Failed to fetch cart',
    };
  } catch (error) {
    console.error('Error fetching guest cart:', error);
    return {
      success: false,
      message: 'Error fetching cart',
    };
  }
};

export default getGuestCart;
